import {createContext} from 'react';

const ReportScreenContext = createContext();
export default ReportScreenContext;
